"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APFilterAmount = void 0;
var TextField_1 = __importDefault(require("@material-ui/core/TextField"));
var SwapVertRounded_1 = __importDefault(require("@material-ui/icons/SwapVertRounded"));
var react_1 = __importStar(require("react"));
var elements_1 = require("../../elements");
var layout_1 = require("../../layout");
var APFilterMenu_1 = require("./APFilterMenu");
function APFilterAmount(_a) {
    var header = _a.header, initialValue = _a.initialValue, onChange = _a.onChange;
    var _b = react_1.useState(initialValue !== null && initialValue !== void 0 ? initialValue : { min: 0, max: 0 }), value = _b[0], setValue = _b[1];
    react_1.useEffect(function () {
        onChange(value);
    }, [value.min, value.max]);
    return (react_1.default.createElement(layout_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'stretch' },
        react_1.default.createElement(APFilterMenu_1.HeaderItem, { text: header }),
        react_1.default.createElement(layout_1.APPadding, { padding: "4px 24px 12px" },
            react_1.default.createElement(layout_1.APColumn, { crossAxisAlignment: 'center', mainAxisSize: 'min', gap: "16px" },
                react_1.default.createElement(layout_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'center', gap: "2px" },
                    react_1.default.createElement(elements_1.APText, { variant: 'subtext', style: { fontSize: "12px" } }, "Min"),
                    react_1.default.createElement(TextField_1.default, { value: value.min ? isNaN(value.min) ? "" : value.min.toString() : "", onChange: function (event) {
                            var num = parseFloat(event.currentTarget.value);
                            setValue(function (prev) { return (__assign(__assign({}, prev), { min: num })); });
                        } })),
                react_1.default.createElement(SwapVertRounded_1.default, { fontSize: 'small', htmlColor: "#888" }),
                react_1.default.createElement(layout_1.APColumn, { mainAxisSize: 'min', crossAxisAlignment: 'center', gap: "2px" },
                    react_1.default.createElement(elements_1.APText, { variant: 'subtext', style: { fontSize: "12px" } }, "Max"),
                    react_1.default.createElement(TextField_1.default, { value: value.max ? isNaN(value.max) ? "" : value.max.toString() : "", onChange: function (event) {
                            var num = parseFloat(event.currentTarget.value);
                            setValue(function (prev) { return (__assign(__assign({}, prev), { max: num })); });
                        } }))))));
}
exports.APFilterAmount = APFilterAmount;
